@if (model) {
    <div class="report-container">
        <header class="report-header">
            <div class="header-left">
                @if (isViewInitialized && logoUrl) {
                    <img class="company-logo" alt="Bulgarian Port Logo" [src]="logoUrl" />
                }
            </div>
            <div class="header-center">
                <h1 class="title">{{ 'PCS Approval Report' | translate }}</h1>
                @if (model.pcsApprovalMainData.documentReference) {
                    <div class="subtitle">
                        {{ model.pcsApprovalMainData.documentReference }}
                    </div>
                }
                <div class="subtitle">
                    {{ model.pcsApprovalMainData.pcsApprovalTypeCode }} -
                    {{ model.pcsApprovalMainData.pcsApprovalTypeName }}
                </div>
            </div>
            <div class="header-right">
                <div class="header-field">
                    <span class="label">{{ 'Printed on' | translate }}:</span>
                    <span class="value">{{ now | date: 'dd.MM.yyyy HH:mm' }}</span>
                </div>
                <div class="header-field">
                    <span class="label">{{ 'Status' | translate }}:</span>
                    <span class="value">
                        {{ model.pcsApprovalMainData?.pcsApprovalStatusCode }} -
                        {{ model.pcsApprovalMainData?.pcsApprovalStatusName }}
                    </span>
                </div>
                @if (model.vesselNotificationData?.terminalDefinedByPortFacility) {
                    <div class="header-field">
                        <span class="label">{{ 'Terminal' | translate }}:</span>
                        <span class="value">{{ model.vesselNotificationData.terminalDefinedByPortFacility }}</span>
                    </div>
                }
            </div>
        </header>
        <main class="report-body">
            @if (model.vesselVisitData) {
                <section class="section">
                    <div class="section-title">{{ 'Vessel Voyage Data' | translate }}</div>
                    <div class="header-main-grid">
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Vessel Name' | translate }}</div>
                            <div class="grid-item-value">{{ model.vesselData.vesselName || '' }}</div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'IMO' | translate }}</div>
                            <div class="grid-item-value">{{ model.vesselData.vesselIMO || '' }}</div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Flag' | translate }}</div>
                            <div class="grid-item-value">{{ model.vesselData.vesselFlag || '' }}</div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'MSW Voyage Number' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.vesselVisitData.mswVoyageNumber || ('N/A' | translate) }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'PCS Voyage Number' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.vesselVisitData.pcsVesselVisitId || ('N/A' | translate) }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'ATA' | translate }}</div>
                            <div class="grid-item-value">
                                {{
                                    (model.vesselVisitData.vesselETA | date: 'dd.MM.yyyy HH:mm') || ('N/A' | translate)
                                }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'ATD' | translate }}</div>
                            <div class="grid-item-value">
                                {{
                                    (model.vesselVisitData.vesselATD | date: 'dd.MM.yyyy HH:mm') || ('N/A' | translate)
                                }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Previous Port' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.vesselNotificationData?.portDefinedByPortFacility || ('N/A' | translate) }}
                            </div>
                        </div>
                    </div>
                </section>
            }
            @if (model.vesselNotificationData) {
                <section class="section">
                    <div class="section-title">{{ 'Vessel Procedure Data' | translate }}</div>
                    <div class="header-main-grid">
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'MSW Procedure Number' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.vesselNotificationData?.mswProcedureNumber || ('N/A' | translate) }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'PCS Procedure Number' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.vesselNotificationData?.pcsVesselNotificationNumber || ('N/A' | translate) }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Vessel Agent Company' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.vesselNotificationData?.currentAgentOrganization || ('N/A' | translate) }}
                            </div>
                        </div>
                    </div>
                </section>
            }
            @if (model.pcsApprovalMainData) {
                <section class="section">
                    <div class="section-title">{{ 'Document Created By' | translate }}</div>
                    <div class="header-main-grid">
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Company' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.pcsApprovalMainData.createdByOrganization || '' }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Created By' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.pcsApprovalMainData.createdByUser || ('N/A' | translate) }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Address' | translate }}</div>
                            <div class="grid-item-value description">
                                {{ model.pcsApprovalMainData.createdByOrganizationAddress }},
                                {{ model.pcsApprovalMainData.createdByOrganizationPostNbr }},
                                {{ model.pcsApprovalMainData.createdByOrganizationCity }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Contacts' | translate }}</div>
                            <div class="grid-item-value description">
                                {{ model.pcsApprovalMainData.createdByOrganizationPhoneNumber }},
                                {{ model.pcsApprovalMainData.createdByOrganizationPhoneNumber1 }},
                                {{ model.pcsApprovalMainData.createdByOrganizationPhoneNumber2 }}
                            </div>
                        </div>
                    </div>
                </section>
            }
            @if (isWaitingForApproval()) {
                <section class="section">
                    <div class="section-title">{{ 'Waiting for Approval' | translate }}</div>
                    <div class="header-main-grid">
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Company' | translate }}</div>
                            <div class="grid-item-value">
                                {{ model.pcsApprovalMainData?.waittingApprovalForOrganization || ('N/A' | translate) }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Address' | translate }}</div>
                            <div class="grid-item-value description">
                                {{ model.pcsApprovalMainData.waittingApprovalForOrganizationAddress }},
                                {{ model.pcsApprovalMainData.waittingApprovalForOrganizationPostNbr }},
                                {{ model.pcsApprovalMainData.waittingApprovalForOrganizationCity }}
                            </div>
                        </div>
                        <div class="grid-item">
                            <div class="grid-item-label">{{ 'Contacts' | translate }}</div>
                            <div class="grid-item-value description">
                                {{ model.pcsApprovalMainData.waittingApprovalForOrganizationPhoneNumber }},
                                {{ model.pcsApprovalMainData.waittingApprovalForOrganizationPhoneNumber1 }},
                                {{ model.pcsApprovalMainData.waittingApprovalForOrganizationPhoneNumber2 }}
                            </div>
                        </div>
                    </div>
                </section>
            }
            @if (model.pcsApprovalActionStatusChanges?.length > 0) {
                <section class="section">
                    <div class="section-title">{{ 'Status Change Overview' | translate }}</div>
                    <div class="table-wrap">
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th>{{ 'From Status' | translate }}</th>
                                    <th>{{ 'To Status' | translate }}</th>
                                    <th>{{ 'Date' | translate }}</th>
                                    <th>{{ 'Changed By Organization' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (change of model.pcsApprovalActionStatusChanges; track change) {
                                    <tr>
                                        <td>{{ change.actionChangeFromStatus }}</td>
                                        <td>{{ change.actionChangeToStatus }}</td>
                                        <td>{{ change.changeStatusDate | date: 'dd.MM.yyyy HH:mm' }}</td>
                                        <td>
                                            {{ change.changedStatusByOrganization || ('N/A' | translate) }}
                                            <span class="text-muted">
                                                ({{ 'By' | translate }} {{ change.changeStatusCreatedBy }})
                                            </span>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </section>
            }
            @if (model.pcsApprovalAdditionalDataActions?.length > 0) {
                <section class="section">
                    <div class="section-title">{{ 'Additional data' | translate }}</div>
                    <div class="table-wrap">
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th>{{ 'Name' | translate }}</th>
                                    <th>{{ 'Value' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (action of model.pcsApprovalAdditionalDataActions; track action) {
                                    <tr>
                                        <td>{{ action.additionalDataGuiName }}</td>
                                        <td>{{ action.additionalDataValue || 'N/A' }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </section>
            }
            <!-- Remarks -->
            @if (model.pcsApprovalRemarks?.length > 0) {
                <section class="section">
                    <div class="section-title">{{ 'Remarks' | translate }}</div>
                    <div class="table-wrap">
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th>{{ 'Created in Status' | translate }}</th>
                                    <th>{{ 'Remark Created By' | translate }}</th>
                                    <th>{{ 'Date' | translate }}</th>
                                    <th>{{ 'Remark' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (remark of model.pcsApprovalRemarks; track remark) {
                                    <tr>
                                        <td>{{ remark.createdInStatus || 'N/A' }}</td>
                                        <td>{{ remark.remarkCreatedByOrganization || 'N/A' }}</td>
                                        <td>{{ remark.createdDate | date: 'dd.MM.yyyy HH:mm' }}</td>
                                        <td class="description">{{ remark.remark }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </section>
            }
            @if (model.pcsApprovalMainData.pcsApprovalTypeCode === 'GEN-ACT') {
                <div class="signatures-section">
                    <div class="signatures-title">{{ 'MANUAL SIGNATURES' | translate }}</div>
                    <div class="signatures-grid">
                        <div class="signature-block">
                            <div class="signature-label">{{ 'Terminal operator' | translate }}</div>
                            <div class="signature-line"></div>
                        </div>
                        <div class="signature-block">
                            <div class="signature-label">{{ 'Customs Office' | translate }}</div>
                            <div class="signature-line"></div>
                        </div>
                        <div class="signature-block">
                            <div class="signature-label">{{ 'Captain Name' | translate }}</div>
                            <div class="signature-line"></div>
                        </div>
                    </div>
                </div>
            }
        </main>
    </div>
}
